import { Pipe, PipeTransform } from '@angular/core';
import { enumData } from '../../../../assets/i18n/enumData';

@Pipe({
  name: 'translocoEnum',
  pure: false
})
export class TranslationPipe implements PipeTransform {
  public translationData;

  constructor() {
    this.translationData = enumData;
  }

  public transform(value: any): string {
    const tag = this.translationData[value];
    if (tag) {
      return tag;
    } else {
      return value;
    }
  }
}
